import { faBan, faCreditCard } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

import { Tag, TagType, FormattedMessage } from '@b-stock/fe-core/bstock-react'

// Presentational only for the LDP header; callers gate on
// `ENABLE_CC_SURFACING` and `isCreditCardEnabled === false`.
const ns = 'Listing.tags'

const IconWrapper = styled.span`
  display: flex;
  gap: 0.25rem;
  padding: 0.125rem 0;
`

const Icon = styled(FontAwesomeIcon)`
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
  align-self: center;
`

export const CreditCardNotAcceptedTag = ({
  'data-testid': dataTestId,
}: {
  'data-testid'?: string
}) => {
  const { formatMessage } = useIntl()

  return (
    <Tag
      type={TagType.normal}
      hoverMessage={
        <FormattedMessage id={`${ns}.creditCardNotAcceptedHover`} />
      }
      data-testid={dataTestId}
    >
      <IconWrapper
        aria-label={formatMessage({ id: `${ns}.creditCardNotAcceptedHover` })}
      >
        <Icon icon={faCreditCard} aria-hidden="true" />
        <Icon icon={faBan} aria-hidden="true" />
      </IconWrapper>
    </Tag>
  )
}
